import "./BackAction.css";
import type { Size, Variant } from "@simplybusiness/mobius";
import { Icon } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import { LinkOrButton } from "../LinkOrButton";
import type { BackActionProps } from "./types";
import { chevronLeft } from "@simplybusiness/icons";
import { useQuestionnaireNavigation } from "../../../../../features/questionnaire";

export const BackAction = (props: BackActionProps) => {
  const {
    label = "Back",
    href,
    icon = chevronLeft,
    iconSize = "sm",
    buttonProps,
    className,
  } = props;

  const { handleBackClick } = useQuestionnaireNavigation();

  const classes = classNames("mobius-actions__back", className);

  const handleClick = () => {
    if (href) {
      window.location.href = href;
    } else {
      handleBackClick();
    }
  };

  return (
    <LinkOrButton
      {...buttonProps}
      onClick={handleClick}
      className={classes}
      variant={"link" as Variant}
      size={"sm" as Size}
    >
      {icon && (
        <Icon icon={icon} size={iconSize} title="Return to previous step" />
      )}
      {label}
    </LinkOrButton>
  );
};
